import { postLogs } from '@client-shared/api/logs.api'
import { ObjectId } from 'bson'

const ENABLE_SERVER_PUSH = true
const PUSH_LOGS_TO_SERVER_INTERVAL = 30000 // 30 seconds
const LOG_LIST_LIMIT = 1000
let isPushToServerRunning = false
let pushToServerInterval

export default {
  install: (app) => {
    const $store = app.config.globalProperties.$store
    const $auth = app.config.globalProperties.$auth
    const $axios = app.config.globalProperties.$axios

    if (!pushToServerInterval) {
      pushToServerInterval = setInterval(pushLogsToServer, PUSH_LOGS_TO_SERVER_INTERVAL)
    }

    // localStorage is synchronous, so nothing gets between a read and the write after it: an entry is stored the moment
    // it is logged, while a push is on its way and as the page goes as well.
    const readStoredLogs = () => JSON.parse(localStorage.getItem('logs') || '[]')

    const writeStoredLogs = (logs) => {
      localStorage.setItem('logs', JSON.stringify(logs.slice(-LOG_LIST_LIMIT)))
    }

    async function pushLogsToServer () {
      if (!ENABLE_SERVER_PUSH || isPushToServerRunning) {
        return
      }

      isPushToServerRunning = true

      try {
        const logs = readStoredLogs()

        if (logs.length === 0) {
          return
        }

        await postLogs({
          axios: $axios,
          logs,
        })

        // Only what was sent: entries logged while the post was on its way go with the next push.
        const sentIds = new Set(logs.map(logEntry => logEntry._id))

        writeStoredLogs(readStoredLogs()
          .filter(logEntry => !sentIds.has(logEntry._id)))
      } catch (err) {
        console.error(err)
      } finally {
        isPushToServerRunning = false
      }
    }

    function log ({ tag, message, context }) {
      try {
        const $route = app.config.globalProperties.$route

        const logEntry = {
          _id: new ObjectId()
            .toString(),
          tag,
          timestamp: new Date()
            .toISOString(),
          userId: $auth.user ? $auth.user._id : undefined,
          projectId: $store.state.project.project ? $store.state.project.project._id : undefined,
          route: $route.name,
          message,
          context,
        }

        if (!logEntry.timestamp) {
          throw new Error('timestamp is required')
        }

        if (!logEntry.tag) {
          throw new Error('tag is required')
        }

        writeStoredLogs([
          ...readStoredLogs(),
          logEntry,
        ])
      } catch (err) {
        console.error('Error while logging', err)
      }
    }

    async function getLogs () {
      try {
        return readStoredLogs()
      } catch (err) {
        console.error('Error while getting logs', err)
      }
    }

    const logger = {
      log,
      getLogs,
      pushLogsToServer,
    }

    app.config.globalProperties.$logger = logger
  },
}
